import { Card, Typography, Grid } from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';

import ListaContaReceber from '../Financeiro/ListaContaReceber';
import { DUPR_STATUS_EM_ABERTO } from '../../constants';

const CardDebitosEmAberto: React.FC = () => {
  const dataInicio = dayjs().startOf('month');
  const dataFim = dayjs().endOf('month');

  return (
    <Grid
      item
      xs={12}
      sx={{
        marginTop: { xs: '0', md: '30px' },
        padding: '10px',
        borderRadius: '12px'
      }}
    >
      <Card
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: '50px',
          padding: '10px',
          marginBottom: '15px'
        }}
      >
        <Typography fontSize={20} style={{ textAlign: 'center' }}>
          Débitos pendentes
        </Typography>
      </Card>

      <ListaContaReceber
        codigoStatus={DUPR_STATUS_EM_ABERTO}
        dataInicio={dataInicio}
        dataFim={dataFim}
      />
    </Grid>
  );
};

export default CardDebitosEmAberto;
